<template>
	<!-- banner -->
	<section v-if="topoBanner != ''" class="home-section hero"
		:style="{ backgroundImage: 'url(' + $imgURL + topoBanner[0].insInstitucionalImagens[0].itgUrlImagem + ')' }">
		<div class="row d-flex texto-banner-internas">
			<div class="container">
				<p class="titulo-cel">{{ topoBanner[0].itiNome }}</p>
			</div>
		</div>
	</section>
	<!-- END banner -->

	<!-- noticias -->
	<section class="ftco-section bg-light">
		<div v-if="listaNoticias != ''" class="container">

			<div class="row d-flex">
				<div v-for="noticia in listaNoticias" :key="noticia.itiId" class="col-md-4 d-flex ">
					<div class="blog-entry justify-content-end">
						<router-link :to="'/noticiasDetalhe/' + noticia.itiId + '/' + formataLink(noticia.itiNome)"
							class="block-20"><img :src="$imgURL + noticia.insInstitucionalImagens[0].itgUrlImagem"
								class="img-fluid">
						</router-link>
						<div class="text mt-3 float-right d-block">
							<div class="d-flex align-items-center mb-3 meta">
								<p class="mb-0">
									<span class="mr-2">{{ formattedDate(noticia.itiData1) }}</span>
								</p>
							</div>
							<h3 class="heading">{{ noticia.itiNome }}</h3>
							<p v-html="noticia.itiResumo1"></p>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<!-- END noticias -->


</template>

<script>
import { useHead } from '@vueuse/head'
import axios from 'axios'

export default {
	name: 'NoticiasView',
	components: {

	},

	data: () => ({
		topoBanner: [],
		listaNoticias: [],
	}),

	methods: {
		formattedDate(value) {
			return this.$moment(value).format('DD/MM/YYYY')
		},
		formataLink(value) {
			return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
		},

		carregaMetas(texto) {
			useHead({
				title: 'Notícias - Induscapas',
				meta: [
					{ name: "description", content: texto },
					{ name: "author", content: "Induscapas" },
					{ httpEquiv: "Content-Language", content: "pt-BR" },
					{ charset: "UTF-8" },
					{ name: "robots", content: "index, follow" },
				],
			})
		},

		toggleAccordion(index) {
			this.activeIndex = this.activeIndex === index ? null : index; // Alterna entre abrir e fechar o item
		},
	},

	created() {
		this.carregaMetas("---");

		//aqui busca o banner
		axios.get('/Process/InsInstitucional/institucional/45/blogtopo/0/x')
			.then(response => {
				this.topoBanner = response.data;
				//console.log('topo Banner')
				//console.log(this.topoBanner)
			})
			.catch(error => {
				console.error(error);
			});
		//aqui busca noticias
		axios.get('/Process/InsInstitucional/institucional/46/listablog/0/x')
			.then(response => {
				this.listaNoticias = response.data.filter(x => x.itiVisivel).sort((a, b) => {
					const timeA = a.itiData1
						? new Date(a.itiData1).getTime()
						: 0;
					const timeB = b.itiData1
						? new Date(b.itiData1).getTime()
						: 0;
					return timeA - timeB;
				}).reverse();
				//console.log('lista noticias')
				//console.log(this.listaNoticias)
			})
			.catch(error => {
				console.error(error);
			});



	},
}

</script>

<style scoped></style>
